import React, {useEffect, useState} from 'react';
import api from '../../../api/axios';
import Cookies from 'js-cookie';
import {useSelectedUserStore} from './SelectedUserStore';

const UserEdit = () => {
    const {selectedUser, clearSelectedUser, setSelectedUser} = useSelectedUserStore();
    const [formData, setFormData] = useState({
        hapakId: '',
        forename: '',
        surname: '',
        email: '',
        companySite: '',
        receiveReports: false,
        employee: false,
        employed: false,
    });

    useEffect(() => {
        if (selectedUser && selectedUser.hapakId) {
            const accessToken = Cookies.get('accessToken');
            if (!accessToken) {
                console.error('Access Token fehlt. Bitte melden Sie sich erneut an.');
                return;
            }

            // Benutzerdaten laden
            api.get(`/api/v1/management/sitemanager/${selectedUser.hapakId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            })
                .then((response) => {
                    setFormData({
                        hapakId: response.data.hapakId || '',
                        forename: response.data.forename || '',
                        surname: response.data.surname || '',
                        email: response.data.email || '',
                        companySite: response.data.companySite || '',
                        receiveReports: response.data.receiveReports || false,
                        employee: response.data.employee || false,
                        employed: response.data.employed || false,
                    });
                })
                .catch((error) => console.error('Fehler beim Laden der Benutzerdaten:', error));
        } else {
            setFormData({
                hapakId: '',
                forename: '',
                surname: '',
                email: '',
                companySite: '',
                receiveReports: false,
                employee: false,
                employed: false,
            });
        }
    }, [selectedUser]);

    const handleInputChange = (e) => {
        const {name, value, type, checked} = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleDelete = () => {
        const accessToken = Cookies.get('accessToken');
        if (!accessToken) {
            console.error('Access Token fehlt. Bitte melden Sie sich erneut an.');
            return;
        }

        const confirmDelete = window.confirm('Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?');
        if (!confirmDelete) return;

        if (selectedUser) {
            api.delete(`/api/v1/management/sitemanager/${selectedUser.hapakId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            })
                .then(() => {
                    clearSelectedUser(); // Benutzer löschen und Popup schließen
                })
                .catch((error) => console.error('Fehler beim Löschen des Benutzers:', error));
        }
    };

    const handleUpdate = () => {
        const accessToken = Cookies.get('accessToken');
        if (!accessToken) {
            console.error('Access Token fehlt. Bitte melden Sie sich erneut an.');
            return;
        }

        if (selectedUser) {
            const dataToUpdate = {
                forename: formData.forename,
                surname: formData.surname,
                email: formData.email,
                employee: formData.employee,
                employed: formData.employed,
                companySite: formData.companySite,
                receiveReports: formData.receiveReports,
            };

            console.log('Senden der Aktualisierungsdaten:', dataToUpdate);

            api.patch(`/api/v1/management/sitemanager/${selectedUser.hapakId}`, dataToUpdate, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            })
                .then(() => {
                    clearSelectedUser(); // Benutzer aktualisieren und Popup schließen
                })
                .catch((error) => {
                    console.error('Fehler beim Aktualisieren des Benutzers:', error.response ? error.response.data : error);
                });
        }
    };


    // Angepasster handleCreate, um die korrekten Felder an die API zu senden
    const handleCreate = () => {
        const accessToken = Cookies.get('accessToken');
        if (!accessToken) {
            console.error('Access Token fehlt. Bitte melden Sie sich erneut an.');
            return;
        }

        const dataToSend = {
            id: formData.hapakId, // Verwende das hapakId-Feld oder generiere eine ID falls erforderlich
            forename: formData.forename,
            surname: formData.surname,
            email: formData.email,
            employee: formData.employee,
            employed: formData.employed,
            companySite: formData.companySite,
            receiveReports: formData.receiveReports
        };

        // Überprüfe, ob alle Pflichtfelder ausgefüllt sind
        if (!dataToSend.forename || !dataToSend.surname || !dataToSend.email || !dataToSend.companySite) {
            console.error('Alle Pflichtfelder müssen ausgefüllt werden.');
            return;
        }

        api.post('/api/v1/management/sitemanager', dataToSend, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
            .then(() => {
                clearSelectedUser(); // Benutzer erstellen und Popup schließen
            })
            .catch((error) => console.error('Fehler beim Erstellen des Bauleiters:', error));
    };

    const handleCancel = () => {
        // Nur das Popup schließen und den Benutzerzustand zurücksetzen
        setSelectedUser(null);
    };

    if (!selectedUser) return null; // Kein Benutzer ausgewählt => Popup wird nicht angezeigt

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-2/8">
                <h2 className="text-xl font-bold mb-4">{selectedUser.hapakId ? 'Benutzer bearbeiten' : 'Neuen Bauleiter anlegen'}</h2>
                <div className="space-y-4">
                    {!selectedUser.hapakId && (
                        <div>
                            <label className="block text-sm font-medium">Hapak-ID</label>
                            <input
                                type="text"
                                name="hapakId"
                                value={formData.hapakId}
                                onChange={handleInputChange}
                                className="w-full p-2 border rounded"
                            />
                        </div>
                    )}
                    <div>
                        <label className="block text-sm font-medium">Vorname</label>
                        <input
                            type="text"
                            name="forename"
                            value={formData.forename}
                            onChange={handleInputChange}
                            className="w-full p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Nachname</label>
                        <input
                            type="text"
                            name="surname"
                            value={formData.surname}
                            onChange={handleInputChange}
                            className="w-full p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">E-Mail</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            className="w-full p-2 border rounded"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium">Standort</label>
                        <input
                            type="text"
                            name="companySite"
                            value={formData.companySite}
                            onChange={handleInputChange}
                            className="w-full p-2 border rounded"
                        />
                    </div>
                    <div className='flex gap-2'>
                        <input
                            type="checkbox"
                            name="receiveReports"
                            checked={formData.receiveReports}
                            onChange={handleInputChange}
                        />
                        <label className="block text-sm font-medium">Berichte erhalten</label>
                    </div>
                    <div className='flex gap-2'>
                        <input
                            type="checkbox"
                            name="employee"
                            checked={formData.employee}
                            onChange={handleInputChange}
                        />
                        <label className="block text-sm font-medium">Mitarbeiter</label>
                    </div>
                    <div className='flex gap-2'>
                        <input
                            type="checkbox"
                            name="employed"
                            checked={formData.employed}
                            onChange={handleInputChange}
                        />
                        <label className="block text-sm font-medium">Aktiv</label>
                    </div>
                </div>
                <div className="mt-6 space-x-2">
                    {selectedUser.hapakId ? (
                        <>
                            <button onClick={handleUpdate} className="bg-color-1 text-white px-4 py-2 rounded">
                                Benutzer aktualisieren
                            </button>
                            <button onClick={handleDelete} className="bg-red-500 text-white px-4 py-2 rounded">
                                Löschen
                            </button>
                        </>
                    ) : (
                        <button onClick={handleCreate} className="bg-green-500 text-white px-4 py-2 rounded">
                            Bauleiter anlegen
                        </button>
                    )}
                    <button onClick={handleCancel} className="bg-color-6 text-white px-4 py-2 rounded">
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UserEdit;
